import { RiCloseLargeFill } from 'react-icons/ri';
import { FiMic } from 'react-icons/fi';
import { IoSearch } from 'react-icons/io5';
import { useEffect } from 'react';

const SearchInput = ({
                         query,
                         suggestion,
                         onChange,
                         onKeyDown,
                         onFocus,
                         onClear,
                         onVoice,
                         isListening,
                         translation,
                         inputRef,
                         onSuggestionClick
                     }) => {

    const handleInput = (e) => {
        const text = e.target.textContent;
        if (text.length >= 200) {
            e.currentTarget.textContent = text.slice(0, 5);
            const range = document.createRange();
            const sel = window.getSelection();
            range.setStart(e.currentTarget.childNodes[0] || e.currentTarget, 5);
            range.collapse(true);
            sel.removeAllRanges();
            sel.addRange(range);
        } else {
            onChange({ target: { value: text } });
        }

    };

    useEffect(() => {
        if (inputRef.current && inputRef.current.textContent !== query) {
            inputRef.current.textContent = query;
            placeCaretAtEnd(inputRef.current);
        }
    }, [query]);

    const placeCaretAtEnd = (el) => {
        el.focus();
        const selection = document.getSelection();
        selection.selectAllChildren(el);
        selection.collapseToEnd();
    };
    useEffect(() => {
        const inputEl = inputRef.current;
        if (inputEl) {
            // These styles make the contentEditable behave like a single-line input
            inputEl.style.overflow = 'hidden';
            // Prevent it from expanding its container
            inputEl.style.maxWidth = '100%';
            inputEl.style.minWidth = '0';
        }
        // Ensure the parent doesn't shrink icons
        const wrapper = inputEl?.parentElement;
        if (wrapper) {
            wrapper.style.display = 'flex';
            wrapper.style.alignItems = 'center';
            wrapper.style.flex = '1';
            wrapper.style.minWidth = '0';
            wrapper.style.overflow = 'hidden'; // Key for containing overflowed children
        }
    }, []);


    const handlePaste = (e) => {
        e.preventDefault();
        const text = e.clipboardData.getData('text/plain');
        const selection = window.getSelection();
        if (!selection.rangeCount) return;
        const range = selection.getRangeAt(0);
        range.deleteContents();
        const textNode = document.createTextNode(text);
        range.insertNode(textNode);
        range.setStartAfter(textNode);
        range.collapse(true);
        selection.removeAllRanges();
        selection.addRange(range);
        handleInput(e);
    };
    return (
        <div className="searchbar">
            <IoSearch className="search-icon" />
            <div className="input-wrapper">
                <div
                    className="editable-input"
                    contentEditable
                    suppressContentEditableWarning
                    ref={inputRef}
                    data-placeholder={translation('lookingFor') + '...'}
                    onInput={handleInput}
                    onKeyDown={(e) =>{
                        if (e.key === 'Enter') {
                        e.preventDefault();
                        onKeyDown(e);
                        } else {
                            onKeyDown(e);
                        }
                    }
                }
                    onFocus={onFocus}
                    onPaste={(e) => handlePaste(e)}
                />
                {query.length > 0 && suggestion && query !== suggestion && (
                    <div className="suggestion-overlay" onClick={onSuggestionClick}>
                        <span className="invisible-text">{query}</span>
                        <span className="suggestion-text">{suggestion.slice(query.length)}</span>
                    </div>
                )}
            </div>
            {query && <RiCloseLargeFill className="clear-icon" onClick={onClear} />}
            <FiMic
                className={`${isListening ? 'listening' : 'mic-icon'}`}
                onClick={onVoice}
            />
        </div>

    );
};

export default SearchInput;
